import { RootStore } from "./rootStore";
import { makeAutoObservable, observable, action, runInAction } from "mobx";
import agent from "../api/agent";
import { IChangeClientState, IClientList } from "../models/client";
import { toast } from "react-toastify";
import { history } from "../..";
import { IUsers, IChangeState } from "../models/user";
import { getDashboardLastUpdate } from "../util/dateOptions";
import { IList } from "../models/listOfValours";
import { ISalesClient } from "../models/dashboard";
import { showError } from "../util/errorTypeEnumsOptions";

export default class ClientStore {
  rootStore: RootStore;
  constructor(rootStore: RootStore) {
    makeAutoObservable(this);
    this.rootStore = rootStore;
  }
  @observable loadClients = false;
  @observable clients: IClientList[] | null = null;
  @observable client: IClientList | null = null;
  @observable loadClient = false;
  @observable btEditClient = false;
  @observable users: IUsers[] = [];
  @observable loadData = false;
  @observable lastUpdate = getDashboardLastUpdate();
  @observable loadDash = false;
  @observable salesFilterOptions: IList[] = [];
  @observable valueSalesFilter = new Date().getFullYear();
  @observable sales: ISalesClient[] = [];

  @action getDash = async (id: string) => {
    this.update(id);
  };

  @action update = async (id: string) => {
    this.getGraphDataYearSuccessDocuments(this.valueSalesFilter, id);
    this.lastUpdate = getDashboardLastUpdate();
    this.loadDash = true;
  };

  @action reset = () => {
    this.loadClient = false;
  };

  @action changeStatebtEditClient = () => {
    this.btEditClient = !this.btEditClient;
  };

  @action getClients = async () => {
    try {
      const cl = await agent.Clients.getClients();
      runInAction(() => {
        this.clients = cl;
      });
    } catch (error) {
      showError(error);
    }
    runInAction(() => {
      this.loadClients = true;
    });
  };

  @action newClient = async (values: any) => {
    this.changeStatebtEditClient();
    try {
      const res = await agent.Clients.newClient(values);
      toast.success("Los datos se han guardado correctamente");
      runInAction(() => {
        this.client = res;
        history.push(`/home/Client/DashboardEditClient/${this.client.id}`);
      });
    } catch (error) {
      showError(error);
    }
    this.changeStatebtEditClient();
  };

  @action updateClient = async (values: any) => {
    this.changeStatebtEditClient();
    try {
      const res = await agent.Clients.updateClient(values);
      toast.success("Los datos se han guardado correctamente");
      runInAction(() => {
        this.client = res;
      });
    } catch (error) {
      showError(error);
    }
    this.changeStatebtEditClient();
  };

  @action getClientById = async (id: string) => {
    try {
      const res = await agent.Clients.getClientById(id);
      runInAction(() => {
        this.client = res;
        this.loadClient = true;
      });
    } catch (error) {
      showError(error);
    }
  };

  @action getClientByIdGraphic = async (id: string) => {
    try {
      const res = await agent.Clients.getClientById(id);
      runInAction(() => {
        this.client = res;
        this.loadClient = true;
      });
    } catch (error) {
      showError(error);
    }
  };

  @action changeClientState = async (clientChangeState: IChangeClientState) => {
    try {
      const change = await agent.Clients.changeClientState(clientChangeState);
      if (change) {
        toast.success("Se ha cambiado el estado correctamente");
        this.getClients();
      } else toast.error("UPS! No se pudo cambiar el estado");
    } catch (error) {
      showError(error);
    }
  };

  @action getUsersByClientId = async () => {
    try {
      const us = await agent.Clients.getUsersByClientId(this.client.id);
      runInAction(() => {
        this.users = us;
      });
    } catch (error) {
      showError(error);
    }
    runInAction(() => {
      this.loadData = true;
    });
  };

  @action changeUserState = async (userChangeState: IChangeState) => {
    try {
      const change = await agent.UserCompany.changeUserState(userChangeState);
      if (change) {
        toast.success("Se ha cambiado el estado correctamente");
        this.getUsersByClientId();
      } else toast.error("UPS! No se pudo cambiar el estado");
    } catch (error) {
      showError(error);
    }
  };

  @action checkUsername = async (username: string) => {
    try {
      return await agent.UserCompany.getCheckRegister(username);
    } catch (error) {
      console.log(error.response.data.ErrorCode);
      return false;
    }
  };

  @action newUserClient = async (values: any) => {
    this.rootStore.buttonLoadingStore.changeState();
    try {
      const user = await agent.Clients.newUserClient(this.client.id, values);
      if (user) {
        toast.success(
          "Usuario creado satisfactoriamente. Se envía mail para crear contraseña"
        );
        this.rootStore.modalStore.closeModal();
        this.getUsersByClientId();
      } else toast.error("UPS! No se pudo crear el usuario");
    } catch (error) {
      showError(error);
    }
    this.rootStore.buttonLoadingStore.changeState();
  };

  @action editUserClient = async (id: any, values: any) => {
    this.rootStore.buttonLoadingStore.changeState();
    try {
      await agent.Clients.editUserClient(id, values);
      toast.success("El usuario se ha actualizado correctamente");
      this.rootStore.modalStore.closeModal();
      this.getUsersByClientId();
    } catch (error) {
      showError(error);
    }
    this.rootStore.buttonLoadingStore.changeState();
  };

  @action getFirstYearOfBilling = async (id: string) => {
    try {
      const lastYear = await agent.ClientsDashboard.getFirstYearOfBilling(id);
      const currentYear = new Date().getFullYear();
      let year = currentYear;
      runInAction(() => {
        this.salesFilterOptions = [];
        while (year >= lastYear) {
          this.salesFilterOptions.push({
            key: `${year}`,
            text: `${year}`,
            value: year,
          });
          year--;
        }
      });
    } catch (error) {
      console.log(error);
    }
  };

  @action getGraphDataYearSuccessDocuments = async (year: any, id: string) => {
    try {
      const sales = await agent.ClientsDashboard.getGraphDataYearSuccessDocuments(
        year,
        id
      );
      runInAction(() => {
        this.sales = sales;
        this.valueSalesFilter = year;
      });
    } catch (error) {
      showError(error);
    }
  };
}
